export default "__VITE_ASSET__BIaSBq40__"